export default __webpack_public_path__ + "static/media/bg_login.bdfee27c.jpg";